import {
  StyledBadge
} from "./chunk-HCDFHGEM.mjs";

// src/components/badge/badge.tsx
import React from "react";
var DeprecatedColorMap = {
  red: "critical",
  orange: "warning",
  green: "success",
  blue: "info",
  purple: "emphasis"
};
var isDeprecatedColor = (color) => DeprecatedColorMap[color] !== void 0;
var Badge = ({ colorPalette, ...rest }) => {
  if (process.env.NODE_ENV !== "production" && colorPalette && isDeprecatedColor(colorPalette)) {
    const newColor = DeprecatedColorMap[colorPalette];
    console.warn(
      `[Badge] colorPalette "${colorPalette}" is deprecated. Use "${newColor}" instead.`
    );
  }
  return /* @__PURE__ */ React.createElement(StyledBadge, { ...rest, colorPalette });
};

export {
  Badge
};
